import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function Menu() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // جلب بيانات الفئات من الـ API
    useEffect(() => {
        console.log('Fetching categories for Menu');
        axios
            .get('https://laravel-api.petra-ms.com/api/categories')
            .then(response => {
                console.log('API Response:', response.data);
                if (response.data.success) {
                    setCategories(response.data.data);
                } else {
                    setError('API returned success: false');
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
                setError(error.message);
                setLoading(false);
            });
    }, []);

    // عرض حالة التحميل
    if (loading) {
        return <div className="text-center py-10">Loading...</div>;
    }

    // عرض حالة الخطأ
    if (error) {
        return <div className="text-center py-10 text-red-500">Error: {error}</div>;
    }

    // عرض حالة عدم وجود فئات
    if (categories.length === 0) {
        return <div className="text-center py-10">No categories available.</div>;
    }

    return (
        <section className="relative py-10">
            <div className="container flex flex-wrap gap-[20px]">
                {categories.map((el) => (
                    <Link
                        to={`/menu-list/${el.id}`}
                        key={el.id}
                        className="w-[48%] bg-white rounded-lg shadow-md overflow-hidden"
                    >
                        <div className="h-[350px]">
                            <img
                                className="w-full h-full object-cover"
                                src={`https://laravel-api.petra-ms.com/storage/app/public/${el.category_img}`}
                                alt={el.category_name}
                                onError={(e) => console.log(`Failed to load image: ${e.target.src}`)}
                            />
                        </div>
                        <div className="p-4 text-center font-bold">{el.category_name}</div>
                    </Link>
                ))}
            </div>
        </section>
    );
}